export default __webpack_public_path__ + "static/media/4-4.1dfda6cb.jpg";